"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountSpecifications_1 = require("./AccountSpecifications");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return AccountSpecifications_1.default; } });
